import { ShieldCheck } from "lucide-react";

export function Brand({ compact = false, light = false }) {
  const main = light ? "text-white" : "text-primary";
  const sub = light ? "text-white/60" : "text-muted-foreground";
  return (
    <div className="flex items-center gap-2.5">
      <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${light ? "bg-white/10" : "bg-primary"} ${light ? "text-white" : "text-primary-foreground"}`}>
        <ShieldCheck className="h-5 w-5" />
      </div>
      <div className="leading-tight">
        <div className={`font-heading text-lg font-bold tracking-tight ${main}`}>Accurate Claims</div>
        {!compact && <div className={`text-[10px] font-semibold uppercase tracking-[0.22em] ${sub}`}>Care · Faith · Accuracy</div>}
      </div>
    </div>
  );
}
